<script>
  import QuestionsSelected from './QuestionsSelected.svelte';
  import QuestionsSelector from './QuestionsSelector.svelte';
  import QuestionsAnswerForm from './QuestionsAnswerForm.svelte';
  import { createEventDispatcher } from 'svelte';
  import CreatorSpotlightAjax from '@ajax/creator_spotlight';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  let showQuestionSelector = true;
  let showQuestionForm = false;
  let showAnswerForm = false;
  let selectedQuestion = {};
  let editingQuestion = {};
  $: selectedQuestions = [];

  let loadCreatorSpotlightQuestions = async function () {
    let res = await CreatorSpotlightAjax.getSpotlightQuestions();
    selectedQuestions = res.questions;
  };

  let deleteCreatorSpotlightQuestion = async function (id) {
    let res = await CreatorSpotlightAjax.deleteSpotlightQuestion(id);
    return res;
  };

  let createCreatorSpotlightQuestion = async function (e) {
    let res = await CreatorSpotlightAjax.createSpotlightQuestion(e.detail);
    return res;
  };

  let editCreatorSpotlightQuestion = async function (e) {
    let res = await CreatorSpotlightAjax.updateSpotlightQuestion(e.detail.id, e.detail.answer);
    return res;
  };

  let submitQuestion = async function (e) {
    // if the user is editing the same question, call edit endpoint
    if (editingQuestion.id === e.detail.id) {
      await editCreatorSpotlightQuestion(e);
      editingQuestion = {};
    } else if (JSON.stringify(editingQuestion) !== '{}' && editingQuestion.id !== e.detail.id) {
      // if the user is editing but it's a different question, remove old question
      // then create new question
      await deleteCreatorSpotlightQuestion(editingQuestion.id);
      await createCreatorSpotlightQuestion(e);
      editingQuestion = {};
    } else {
      // if it's not editing, create a new question
      await createCreatorSpotlightQuestion(e);
    }

    loadCreatorSpotlightQuestions();
    goToQuestionSelector();
  };

  let goToQuestionSelector = function () {
    loadCreatorSpotlightQuestions();
    showQuestionSelector = true;
    showQuestionForm = false;
    showAnswerForm = false;
  };

  let goToQuestionForm = function () {
    showQuestionSelector = false;
    showQuestionForm = true;
    showAnswerForm = false;
  };

  let goToAnswerForm = function (event) {
    selectedQuestion = { ...event.detail };
    showQuestionSelector = false;
    showQuestionForm = false;
    showAnswerForm = true;
  };

  loadCreatorSpotlightQuestions();
</script>

<div>
  <div style={showQuestionSelector ? 'display: block' : 'display: none'}>
    <QuestionsSelected
      mobile={mobile}
      on:close={() => dispatch('close')}
      on:back={() => dispatch('back')}
      on:finished={() => dispatch('finished')}
      on:goToQuestion={() => goToQuestionForm()}
      on:edit={(e) => {
        editingQuestion = e.detail;
        goToAnswerForm(e);
      }}
      selectedQuestions={selectedQuestions} />
  </div>
  <div style={showQuestionForm ? 'display: block' : 'display: none'}>
    <QuestionsSelector
      mobile={mobile}
      on:goToAnswer={(e) => goToAnswerForm(e)}
      on:close={() => dispatch('close')}
      on:back={() => goToQuestionSelector()} />
  </div>
  {#if showAnswerForm}
    <QuestionsAnswerForm
      mobile={mobile}
      on:close={() => dispatch('close')}
      on:back={() => goToQuestionSelector()}
      on:newQuestion={() => goToQuestionForm()}
      on:submit={(e) => submitQuestion(e)}
      selectedQuestion={selectedQuestion} />
  {/if}
</div>
